import { ref, Ref, h } from 'vue'
import { useRouter } from 'vue-router'
import { InvoiceUserSelectStorage } from '@/storage/invoice'
import { showNormalToast, showConfirmModal } from '@/utils/tools'
import { formatInvoiceItem, OrderInvoiceApplyInfo, OrderSubmitInvoiceData } from '@/types/invoice'
import InvoiceUnSelectMessage from '@/components/invoice/invoice-unselect-message.vue'

export function useOrderApply(): {
  changeHandle: (value: OrderInvoiceApplyInfo) => void
  invoiceData: Ref<OrderInvoiceApplyInfo | null>
  verify: () => boolean
  invoiceDomInit: (value: HTMLElement) => void
  scrollToInvoiceDom: () => void
  getOrderInvocieSubmitParams: () => OrderSubmitInvoiceData
  getOrderInvocieData: () => OrderInvoiceApplyInfo | null

} {
  const $router = useRouter()
  const invoiceData: Ref<OrderInvoiceApplyInfo | null> = ref(null)
  const invoiceDom = ref(null)

  function changeHandle(value: OrderInvoiceApplyInfo) {
    invoiceData.value = value
  }
  async function useInvoiceConfirm() {
    try {
      await showConfirmModal({
        title: '温馨提示',
        width: 300,
        message: () => h(InvoiceUnSelectMessage),
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '选择发票抬头',
        cancelButtonText: '暂不选择',
        className: 'nongfu-dialog-confirm-class',
      })
      $router.push({
        name: 'invoice-user-invoice-list',
      })
    } catch (error) {
      console.log('error', error)
    }
  }

  function verify() {
    console.log('dddd')
    if (!invoiceData.value) {
      useInvoiceConfirm()

      return false
    }
    return true
  }
  function invoiceDomInit(value: HTMLElement) {
    invoiceDom.value = value
  }
  function scrollToInvoiceDom() {
    if (invoiceDom.value) {
      invoiceDom.value.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  function getOrderInvocieData() {
    return invoiceData.value

  }

  function getOrderInvocieSubmitParams() {
    const data = invoiceData.value
    const params = {
      invoice_type: data.invoice_type,
      invoice_guid: data.invoice_guid,
      address_guid: '',
    }
    return params
  }
  const storageData = InvoiceUserSelectStorage.get<formatInvoiceItem>()
  if (storageData) {
    // 如果有值代表从发票列表页跳转过来，取值后删除
    invoiceData.value = {
      ...storageData,
      invoice_guid: storageData.guid,
    }
    console.log('222', invoiceData.value)
    InvoiceUserSelectStorage.clear()
  }
  return {
    invoiceData,
    changeHandle,
    verify,
    invoiceDomInit,
    scrollToInvoiceDom,
    getOrderInvocieSubmitParams,
    getOrderInvocieData
  }
}
